// ============== imports ==================
import './index.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import {Raycaster} from "three";
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
// ============ END imports ================

// ============== constant ==================
const API_BASE_URL = localStorage.getItem('API_BASE_URL') || '/api';
const MODEL_LIST_LINK = API_BASE_URL + '/model-list'; // link to get the list of all available models
const MODEL_FILES_LINK = API_BASE_URL + '/uploads?id='; // get the files of a specific model
const MODEL_CONFIG_LINK = API_BASE_URL + '/upload-config'; // link to upload a config file
const MODEL_PATH = "/models/"; // the local path to the model files
const HEADERS = {'Access-Control-Allow-Origin':'*'}; // headers for all requests to the api

const DRACO_LOADER = new DRACOLoader(); // handles decompressing of 3D meshes
const GLTF_LOADER = new GLTFLoader(); // create GLTF loader
const HDR_LOADER = new RGBELoader(); // create HDR loader
const EXR_LOADER = new EXRLoader(); // create EXR loader

const MARKER_UNSELECT_COLOR = 0x94b3fd;
const MARKER_SELECT_COLOR = 0xfd9494;
// ============ END constant ================

// ============== init Three.js ==================
const canvas = document.querySelector('canvas.webgl'); // get the canvas to put the scene
const scene = new THREE.Scene(); // create the scene

// create a floor
const planeW = 50; // pixels
const planeH = 50; // pixels
const numW = 50; // how many wide (50*50 = 2500 pixels wide)
const numH = 50; // how many tall (50*50 = 2500 pixels tall)
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry( planeW*numW, planeH*numH, planeW, planeH ),
    new THREE.MeshBasicMaterial( {
        color: 0xffffff,
        wireframe: true
    } )
);
floor.rotation.x = -Math.PI * 0.5;
floor.name = "floor";
scene.add(floor);

// add a general light to the scene
const hlight = new THREE.AmbientLight (0x404040,5);
scene.add(hlight);


// var to hold the size of the screen
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
// add event to resize the scene when the window of the browser changes size
window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});
// ============ END init Three.js ================

// ============== slider params ================
// add listener on params to apply changes
//model scale
const slide_scale = document.getElementById('slide-scale');
const slider_scale_div = document.getElementById("slide-scale-amount");
slide_scale.onchange = function() {
    slider_scale_div.innerHTML = "Scale : " + this.value;
    currentModel.scale.set(this.value, this.value, this.value);
}
// height of model
const slide_position = document.getElementById('slide-position');
const slider_position_div = document.getElementById("slide-position-amount");
slide_position.onchange = function() {
    slider_position_div.innerHTML = "Position : " + this.value;
    currentModel.position.set(currentModel.position.x, this.value, currentModel.position.z);
}
// light level
const slide_light = document.getElementById('slide-light');
const slider_light_div = document.getElementById("slide-light-amount");
slide_light.onchange = function() {
    slider_light_div.innerHTML = "Light : " + this.value;
    hlight.intensity = this.value;
}
// speed of movements
const slide_speed = document.getElementById('slide-speed');
const slider_speed_div = document.getElementById("slide-speed-amount");
slide_speed.onchange = function() {
    slider_speed_div.innerHTML = "Speed : " + this.value;
    moveDistance = this.value * 0.2;
}
// speed of rotation
const slide_rotation = document.getElementById('slide-rotation');
const slider_rotation_div = document.getElementById("slide-rotation-amount");
slide_rotation.onchange = function() {
    slider_rotation_div.innerHTML = "Rotation : " + this.value;
    rotateAngle = Math.PI / 2 * (this.value / 100);
}
// marker's size
const slide_marker = document.getElementById('slide-marker');
const slider_marker_div = document.getElementById("slide-marker-amount");
slide_marker.onchange = function() {
    slider_marker_div.innerHTML = "Marker : " + this.value;
    marker_r = this.value;
}
// ============ END slider params ==============

// ============== get models ================
/**
 * send a request to the API to get the 3D model's names available.
 * also put each name in the dropdown box to select the first model and to select additional ones
 */
function getModelList(){
    // find dropdown boxes
    var select1 = document.getElementById("model-list");
    var select2 = document.getElementById("model-add-list");
    // remove previous choices, if any
    var i, L = select1.options.length - 1;
    for(i = L; i >= 0; i--) {
        select1.remove(i);
        select2.remove(i);
    }
    // send request to API
    fetch(MODEL_LIST_LINK, {
        method: "GET",
        mode: 'cors',
        headers: HEADERS,
    }).then(async (response) => {
        // request is successful
        var data = await response.text();
        data = JSON.parse(data); // transform the data received
        for (let i = 0; i < data.length; i++) {
            // for each name, create an option for both dropdown boxes
            const opt = document.createElement("option");
            opt.value = data[i];
            opt.text = data[i];
            const opt2 = document.createElement("option");
            opt2.value = data[i];
            opt2.text = data[i];
            select1.add(opt, null);
            select2.add(opt2, null);
        }
    });
}
getModelList(); // launch the request when loading
// add click listeners to both dropdown boxes to load the model
document.getElementById("load-btn").onclick = function() {
    loadModel(document.getElementById("model-list"))
};
document.getElementById("load-add-btn").onclick = function() {
    loadModel(document.getElementById("model-add-list"));
};
// ============ END get models ==============

// ============== load models ================
DRACO_LOADER.setDecoderPath('/draco/');
GLTF_LOADER.setDRACOLoader(DRACO_LOADER); // tell the GLTF loader to use DRACO

let currentModel; // var to store the current model to apply modifications
let models=[]; // storage for all the models added to the scene
let modelId = 0; // the id of the current model
let firstModelName = ""; // the name of the first model
let firstModelUploaded = false; // true if a model has been uploaded
let firstModel=null; // the first model to ever be uploaded

/**
 * get the files linked to a model and search for the model file (.gtlf, .hdr, .exr).
 * load the model and add it to the scene + gui
 * @param modelSelector the dropdown box with the model name selected
 */
function loadModel(modelSelector){
    const modelName = modelSelector.value; // get the name of the model from the dropdown box
    let doCheckConfig = false; // var to know if there is a config file present in the model
    // check if a model has already been uploaded
    if(!firstModelUploaded) {
        // no model has been uploaded, we need to check for a config file
        firstModelUploaded = true;
        firstModelName = modelName;
        doCheckConfig = true;
    }
    // send request to server to get the files of the model
    fetch(MODEL_FILES_LINK+modelName, {
        method: "GET",
        mode: 'cors',
        headers: HEADERS,
    }).then(async (response) => {
        // request is successful --> decode response
        console.log(response);
        const data = await response.text();
        const fileList = JSON.parse(data); // the list of files concerning the model
        // iterate through all the files to check for a GLTF, HDR or EXR file
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if(file.endsWith(".gltf")){
                // we found the model file as GLTF format --> load the model
                GLTF_LOADER.load(MODEL_PATH+modelName+"/"+file, (gltf) => {
                    // loading done
                    addModelToScene(gltf.scene, doCheckConfig, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }else if(file.endsWith(".exr")){
                // we found the model file as EXR format --> load model
                EXR_LOADER.load( MODEL_PATH+modelName+"/"+file, ( texture, textureData ) => {
                    const material = new THREE.MeshBasicMaterial( { map: texture } );
                    const quad = new THREE.PlaneGeometry( 1.5 * textureData.width / textureData.height, 1.5 );
                    const mesh = new THREE.Mesh( quad, material );
                    addModelToScene(mesh, doCheckConfig, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }else if(file.endsWith(".hdr")){
                // we found the model file as HDR format --> load model
                HDR_LOADER.load( MODEL_PATH+modelName+"/"+file, function ( texture, textureData ) {
                    const material = new THREE.MeshBasicMaterial( { map: texture } );
                    const quad = new THREE.PlaneGeometry( 1.5 * textureData.width / textureData.height, 1.5 );
                    const mesh = new THREE.Mesh( quad, material );
                    addModelToScene(mesh, doCheckConfig, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }
        }
    });

}

/**
 * add a model to the scene. Also check if we need to find a config file
 * @param model the model to add to the scene
 * @param doCheckConfig true if we need to find a config file, else false
 * @param modelName the name of the model we're adding to the scene
 */
function addModelToScene(model, doCheckConfig, modelName){
    // add the model to the scene
    currentModel = model;
    currentModel.scale.set(0.5,0.5,0.5);
    scene.add(currentModel);
    currentModel.position.set(camera.position.x, 0.5, camera.position.z);
    // show the scene to the user
    document.getElementById("blocker").setAttribute("style", "display: none;");
    addModelToGUI(); // add the model into the gui
    if(doCheckConfig) checkForConfig(modelName); // need to check a config file
    // show success toast to user
    const toast = document.getElementById("snackbar-import");
    toast.className = "show";
    setTimeout(function(){ toast.className = toast.className.replace("show", ""); }, 3000);
}

/**
 * search for a config file of a specific model.
 * it's possible that the request fails if there is no file (first time loading the model for example)
 * @param modelName the name of the model we need to find a config file for
 */
function checkForConfig(modelName){
    // search the config file locally
    fetch(MODEL_PATH + modelName + "/config.json").then(response => response.json()).then(json => {
        // config file found
        json = JSON.parse(json);
        // handles the scene parameters
        // light
        let light = json.params.light;
        slider_light_div.innerHTML = "Light : " + light;
        slide_light.value = light;
        hlight.intensity = light;
        // scale
        const scale = json.params.scale;
        slider_scale_div.innerHTML = "Scale : " + scale;
        slide_scale.value = scale;
        currentModel.scale.set(scale, scale, scale);
        // speed
        const speed = json.params.speed;
        slider_speed_div.innerHTML = "Speed : " + speed;
        slide_speed.value = speed;
        moveDistance = speed * 0.2;
        // rotation
        const rotation = json.params.rotation;
        slider_rotation_div.innerHTML = "Rotation : " + rotation;
        slide_rotation.value = rotation;
        rotateAngle = Math.PI / 2 * (rotation / 100);
        // marker
        const marker = json.params.marker;
        slider_marker_div.innerHTML = "Marker : " + marker;
        slide_marker.value = marker;
        marker_r = marker;
        // position
        const position = json.params.position;
        slider_position_div.innerHTML = "Position : " + position;
        slide_position.value = position;
        currentModel.position.set(currentModel.position.x, position, currentModel.position.z);
        // markers
        const markersList = json.markers;
        // iterate through all the markers
        for (let i = 0; i < markersList.length; i++) {
            // create the marker in the scene and GUI
            createMarker(markersList[i]);
        }
    }).catch(function() {
        // request failed --> it's not a problem there is just no config file
        console.log('Config file not found');
    });
    firstModel = currentModel; // save the fist model added to the scene
}

/**
 * add a button in the GUI the select the model
 */
function addModelToGUI(){
    // add object to array as storage
    models.push(currentModel);
    // add button in GUI
    const modelsGUI = document.getElementById("models-content");
    modelsGUI.innerHTML += "<div id=\"model-selector-"+modelId+"\"><input type=\"radio\" class=\"btn-check\" id=\"model-check-"+modelId+"\" " +
        "autocomplete=\"off\" name=\"options-outlined\" value=\""+modelId+"\">\n" +
        "<label class=\"btn btn-outline-primary\" for=\"model-check-"+modelId+"\">Model "+modelId+"</label></br></br></div>";
    // add event on buttons --> needs to refresh every button
    for (let i = 0; i < modelId+1; i++) {
        const radioBtn = document.getElementById("model-check-"+i);
        if(radioBtn!==null) {
            radioBtn.addEventListener('change', function () {
                modelSelect(this.value)
            });
        }
    }
    modelId++; // increment the id of the model
}

/**
 * change the current model selected
 * @param modelNumber the id of the model selected
 */
function modelSelect(modelNumber){
    currentModel = models[modelNumber];
}
// ============ END load models ==============

// ============== controls system ================
//create the perspective camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 500000);
camera.position.set(2, 2, 2); // set the camera initial position
camera.rotation.order = "YXZ"; // set the rotation order --> used to prevent weird behavior
scene.add(camera); // add the camera to the scene

// var to know if a keyboard key is currently pressed
var isForward = false;
var isBackward = false;
var isLeft = false;
var isRight = false;
var isUp = false;
var isDown = false;
var isRotateLeft = false;
var isRotateRight = false;
var isRotateUp = false;
var isRotateDown = false;
var isMoveModelLeft = false;
var isMoveModelRight = false;
var isMoveModelForward = false;
var isMoveModelBackward = false;

// add event when the user press a key
document.addEventListener('keydown', (event) => {
    // switch through the keyboard keys we are interested in
    switch (event.code) {
        case 'KeyW':
            isForward=true;
            break
        case 'KeyA':
            isLeft=true;
            break
        case 'KeyS':
            isBackward=true;
            break
        case 'KeyD':
            isRight=true;
            break
        case 'ShiftLeft':
            isUp=true;
            break
        case 'Space':
            isDown=true;
            break
        case 'ArrowLeft':
            isRotateLeft=true;
            break
        case 'ArrowRight':
            isRotateRight=true;
            break
        case 'ArrowUp':
            isRotateUp=true;
            break
        case 'ArrowDown':
            isRotateDown=true;
            break
        case 'Enter':
            addMarker(); // single key press --> add a marker
            break
        case 'Delete':
            deleteMarker(); // single key press --> delete a marker
            break
        case 'KeyI':
            isMoveModelForward=true;
            break
        case 'KeyK':
            isMoveModelBackward=true;
            break
        case 'KeyJ':
            isMoveModelLeft=true;
            break
        case 'KeyL':
            isMoveModelRight=true;
            break
    }
}, false);

// add event when the user releases a key
document.addEventListener('keyup', (event) => {
    // switch through the keyboard keys we are interested in
    switch (event.code) {
        case 'KeyW':
            isForward=false;
            break
        case 'KeyA':
            isLeft=false;
            break
        case 'KeyS':
            isBackward=false;
            break
        case 'KeyD':
            isRight=false;
            break
        case 'ShiftLeft':
            isUp=false;
            break
        case 'Space':
            isDown=false;
            break
        case 'ArrowLeft':
            isRotateLeft=false;
            break
        case 'ArrowRight':
            isRotateRight=false;
            break
        case 'ArrowUp':
            isRotateUp=false;
            break
        case 'ArrowDown':
            isRotateDown=false;
            break
        case 'KeyI':
            isMoveModelForward=false;
            break
        case 'KeyK':
            isMoveModelBackward=false;
            break
        case 'KeyJ':
            isMoveModelLeft=false;
            break
        case 'KeyL':
            isMoveModelRight=false;
            break
    }
}, false);

// var to save the movements speed
let moveDistance = 50 * 0.2;
let rotateAngle = Math.PI / 2 * 0.01;
let modelSpeed = 0.5;

/**
 * checks every control key to know if it's pressed. If that's the case, move the camera accordingly
 */
function updateMovements(){
    if(isForward){
        camera.translateZ( -moveDistance );
    }
    if(isBackward){
        camera.translateZ(  moveDistance );
    }
    if(isLeft){
        camera.translateX( -moveDistance );
    }
    if(isRight){
        camera.translateX(  moveDistance );
    }
    if(isUp){
        camera.position.y -= moveDistance;
    }
    if(isDown){
        camera.position.y += moveDistance;
    }
    if(isRotateLeft){
        camera.rotation.y += rotateAngle;
    }
    if(isRotateRight){
        camera.rotation.y -= rotateAngle;
    }
    if(isRotateUp){
        camera.rotation.x += rotateAngle;
    }
    if(isRotateDown){
        camera.rotation.x -= rotateAngle;
    }
    if(isMoveModelForward){
        currentModel.position.z -= modelSpeed;
    }
    if(isMoveModelBackward){
        currentModel.position.z += modelSpeed;
    }
    if(isMoveModelLeft){
        currentModel.position.x -= modelSpeed;
    }
    if(isMoveModelRight){
        currentModel.position.x += modelSpeed;
    }
}
// ============ END controls system ==============

// ============== marker handling ================
let marker_r = 20; // the radius of the circle to show in the scene
let markers = []; // the list of markers
let markersId = 0; // id of the marker to differentiate them
let prevMarker = null; // the last marker selected

/**
 * find the position to add a marker
 */
function addMarker(){
    // create a raycast to know the position of the first child element downwards
    var ray = new Raycaster();
    var rayPos = new THREE.Vector3();
    rayPos.set(camera.position.x, camera.position.y, camera.position.z);
    var rayDir = new THREE.Vector3(0, -1, 0); // Ray points down
    // Set ray from pos, pointing down
    ray.set(rayPos, rayDir);
    // Check where it intersects terrain Mesh
    let intersect = ray.intersectObjects(scene.children, true);
    let position = new THREE.Vector3(camera.position.x, intersect[0].point.y+1, camera.position.z);
    //create the circle
    createMarker(position);
}

/**
 * add a marker at a specific position in the scene and in the GUI
 * @param position the position in the scene where to add the marker
 */
function createMarker(position){
    const geometry = new THREE.CircleGeometry(marker_r, 32);
    const material = new THREE.MeshBasicMaterial({color: MARKER_UNSELECT_COLOR});
    const circle = new THREE.Mesh(geometry, material);
    circle.rotation.x = 11;
    circle.position.x = position.x;
    circle.position.y = position.y;
    circle.position.z = position.z;
    circle.name = "marker"+markersId;
    scene.add(circle);
    // add object to array as storage
    markers.push(circle);
    // add button in GUI
    const markerGUI = document.getElementById("markers-content");
    markerGUI.innerHTML += "<div id=\"marker-selector-" + markersId + "\"><input type=\"radio\" class=\"btn-check\" id=\"marker-check-" + markersId + "\" " +
        "autocomplete=\"off\" name=\"options-outlined\" value=\"" + markersId + "\">\n" +
        "<label class=\"btn btn-outline-primary\" for=\"marker-check-" + markersId + "\">Marker " + markersId + "</label></br></br></div>";
    // add event on button
    for (let i = 0; i < markersId + 1; i++) {
        const radioBtn = document.getElementById("marker-check-" + i);
        if (radioBtn !== null) {
            radioBtn.addEventListener('change', function () {
                markerSelect(this.value)
            });
        }
    }
    markersId++; // increment the next id
}

/**
 * function called to select a specific marker
 * @param markerNumber the id of the marker
 */
function markerSelect(markerNumber){
    if(prevMarker!=null){
        // if there is a previous marker --> need to change it's color
        markers[prevMarker].material.color.setHex(MARKER_UNSELECT_COLOR);
    }
    prevMarker = markerNumber; // update the current marker
    markers[prevMarker].material.color.setHex(MARKER_SELECT_COLOR); // change it's color to selected
}

/**
 * delete the selected marker
 */
function deleteMarker(){
    if(prevMarker!==null){
        // a marker is selected
        scene.remove(markers[prevMarker]); // remove the circle from the scene
        markers[prevMarker] = null; // remove the marker from the list
        // remove marker from GUI
        document.getElementById("marker-selector-"+prevMarker).outerHTML = "";
        prevMarker = null;
    }
}
// ============ END marker handling ==============

// ============== object highlight ================
let mouse = new THREE.Vector2(); // the position of the mouse
let currentObjectPointed; // the last object pointed at
let oldColor = 0xffffff; // the initial color of the object pointed at

// add listener on mouse movement to detect if it points at an object in the scene
document.addEventListener('mousemove', (event) => {
    // get the position of the mouse
    mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    var vector = new THREE.Vector3(mouse.x, mouse.y, 1);
    vector.unproject(camera);
    // cast a vector to detect the object that the mouse points at
    var raycaster = new THREE.Raycaster( camera.position, vector.sub(camera.position).normalize() );
    var intersects = raycaster.intersectObjects(scene.children, true);
    if (intersects.length > 0) {
        // we have detected a collision
        if (currentObjectPointed != intersects[0].object) {
            // the object colliding is different than the previous one
            if (currentObjectPointed){
                // reset color of last pointed object
                currentObjectPointed.material.color.set( oldColor );
            }
            currentObjectPointed = intersects[0].object;
            oldColor = currentObjectPointed.material.color.getHex(); // save the color of the current object
            document.getElementById("current-object").innerHTML = currentObjectPointed.name; // write the name
            currentObjectPointed.material.color.set( 0x808080); // set a new color
        }
    } else {
        // we are not colliding with any object --> reset colors
        if (currentObjectPointed) currentObjectPointed.material.color.set( oldColor);
        currentObjectPointed = null;
    }
})
// ============ END object highlight ==============

// ============== save config ================
document.getElementById("exportBtn").onclick = function() {exportJson()}; // add click function to save button

/**
 * prepare the data to send to the API. The config is in JSON
 */
function exportJson(){
    var json = new Object(); // create the main JSON object
    var params = new Object(); // create the params JSON object
    // set value of the params
    params.light = slide_light.value;
    params.scale = firstModel.scale.x; // depend on the model currentModel.scale
    params.speed = slide_speed.value;
    params.rotation = slide_rotation.value;
    params.marker = slide_marker.value;
    params.position = firstModel.position.y; // depend on the model currentModel.position
    json.params = params; // set the params in the main JSON
    // create the JSON for each marker inside an array
    var markersJson = []
    for (let i = 0; i < markers.length; i++) {
        if(markers[i]!=null) {
            var marker = new Object();
            marker.x = markers[i].position.x;
            marker.y = markers[i].position.y;
            marker.z = markers[i].position.z;
            markersJson.push(marker);
        }
    }
    json.markers = markersJson; // add the markers to the main JSON
    downloadObjectAsJson(json); // send the JSON
}

/**
 * send the config file (JSON) to the API as to store it inside the model
 * @param exportObj the JSON to send
 */
function downloadObjectAsJson(exportObj){
    // prepare the data to send
    const formData = new FormData();
    formData.append('config', JSON.stringify(exportObj));
    formData.append('model', firstModelName);
    // send the request
    fetch(MODEL_CONFIG_LINK, {
        method: "POST",
        mode: 'cors',
        headers: HEADERS,
        body: formData,
    }).then(async (response) => {
        // upload is successful --> show toast to user
        var toast = document.getElementById("snackbar-save");
        toast.className = "show";
        setTimeout(function(){ toast.className = toast.className.replace("show", ""); }, 3000);
    });
}
// ============ END save config ==============

// ============== start program ================
// create the renderer of Three.js --> generate what to show
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * main function of the program. This is what allows the program to refresh what is shown in the scene
 */
function animate() {
    requestAnimationFrame(animate);
    updateMovements(); // generate new position
    renderer.render(scene, camera); // refresh the scene
}

animate(); // start the program
// ============ END start program ==============
